import React from "react";
import { Collapse as ReactCollapse, UnmountClosed } from "react-collapse";
import classNames from "classnames";
import classes from "./collapse.scss";

type CollapseProps = {
  className?: string;
  isOpened: boolean;
  unmountOnClosed?: boolean;
};

export default function Collapse({
  children,
  className,
  isOpened,
  unmountOnClosed,
}: React.PropsWithChildren<CollapseProps>) {
  const CollapseToUse =
    unmountOnClosed === true ? UnmountClosed : ReactCollapse;
  return (
    <div
      className={classNames(classes, className, {
        isOpened,
      })}
    >
      <CollapseToUse isOpened={isOpened}>{children}</CollapseToUse>
    </div>
  );
}
